<template>
  <nav class="space-y-4 h-screen px-2">
    <!-- Admin/Staff Links -->
    <div v-if="adminLinks.length">
      <h4 class="text-gray-400 uppercase text-xs font-semibold mb-2">Staff Panel</h4>
      <template v-for="link in adminLinks" :key="link.name">
        <router-link
          :to="link.to"
          class="flex items-center space-x-2 p-3 rounded-lg hover:bg-gray-700"
          active-class="bg-blue-500"
        >
          <font-awesome-icon :icon="link.icon" />
          <span>{{ link.label }}</span>
        </router-link>
      </template>
      <hr class="border-gray-600 my-2" />
    </div>

    <!-- Client Links -->
    <div v-if="clientLinks.length">
      <h4 class="text-gray-400 uppercase text-xs font-semibold mb-2">Client Panel</h4>
      <template v-for="link in clientLinks" :key="link.name">
        <router-link
          :to="link.to"
          class="flex items-center space-x-2 p-3 rounded-lg hover:bg-gray-700"
          active-class="bg-blue-500"
        >
          <font-awesome-icon :icon="link.icon" />
          <span>{{ link.label }}</span>
        </router-link>
      </template>
    </div>
  </nav>
</template>

<script>
import axios from 'axios';
import { RouterLink } from 'vue-router';

export default {
  name: 'NavBar',
  data() {
    return {
      userPermissions: [],
      links: [
        // Staff links
        { name: 'dashboard', label: 'Dashboard', to: '/admin/dashboard', icon: ['fas', 'chart-line'], permission: 'view_dashboard', type: 'staff' },
        { name: 'orders', label: 'Orders', to: '/admin/orders', icon: ['fas', 'box'], permission: 'view_orders', type: 'staff' },
        { name: 'affiliates', label: 'Affiliates', to: '/admin/affiliates', icon: ['fas', 'user-tie'], permission: 'view_affiliates', type: 'staff' },
        { name: 'users', label: 'View Users', to: '/admin/users', icon: ['fas', 'user-group'], permission: 'view_users', type: 'staff' },
        { name: 'tickets', label: 'View Tickets', to: '/admin/tickets', icon: ['fas', 'ticket'], permission: 'view_tickets', type: 'staff' },
        { name: 'servers', label: 'View Servers', to: '/admin/servers', icon: ['fas', 'bars-progress'], permission: 'view_servers', type: 'staff' },
        { name: 'nodes', label: 'Nodes', to: '/admin/nodes', icon: ['fas', 'server'], permission: 'view_nodes', type: 'staff' },
        { name: 'networks', label: 'Networks', to: '/admin/networks', icon: ['fas', 'network-wired'], permission: 'view_networks', type: 'staff' },
        { name: 'income-report', label: 'Income Report', to: '/admin/income-report', icon: ['fas', 'file-invoice-dollar'], permission: 'view_income_reports', type: 'staff' },
        { name: 'staff', label: 'View Staff', to: '/admin/staff', icon: ['fas', 'clipboard-user'], permission: 'view_roles', type: 'staff' },
        { name: 'roles', label: 'Staff Roles', to: '/admin/roles', icon: ['fas', 'sitemap'], permission: 'view_roles', type: 'staff' },

        // Client links
        { name: 'user-dashboard', label: 'Client Dashboard', to: '/dashboard', icon: ['fas', 'layer-group'], permission: 'view_dashboard', type: 'client' }
      ]
    };
  },
  computed: {
    adminLinks() {
      return this.links.filter(link => link.type === 'staff' && this.userPermissions.includes(link.permission));
    },
    clientLinks() {
      return this.links.filter(link => link.type === 'client' && this.userPermissions.includes(link.permission));
    }
  },
  async created() {
    try {
      const response = await axios.get('https://api.syniac.com:3000/api/auth/session', { withCredentials: true });
      if (response.data.loggedIn) {
        this.userPermissions = response.data.user.permissions || [];
      }
    } catch (error) {
      console.error('Error fetching session:', error);
    }
  },
  components: { RouterLink }
};
</script>
